// ChaptersRail.jsx — left column listing the REAL DRHP chapters from the
// seeded template, grouped by SEBI ICDR section, with status dots.
// Purely prop-driven (the parent is the single source of chapter data) to
// avoid duplicate concurrent /chapters fetches.

import React from 'react';

const DOT = { done: 'cs-done', review: 'cs-review', draft: 'cs-draft', empty: 'cs-empty' };

// Shorten the long all-caps section labels for the rail.
const shortSection = (s) => {
  if (!s) return 'General';
  const m = s.match(/SECTION\s+([IVXLC]+)/i);
  const tail = s.split(/[-–—]/).slice(1).join('–').trim();
  return (m ? `${m[1]} · ` : '') + (tail || s).replace(/^SECTION\s+[IVXLC]+\s*/i, '');
};

export default function ChaptersRail({ active, onSelect, chapters: chaptersProp }) {
  const chapters = chaptersProp || [];

  // Group chapters under their section heading.
  const groups = [];
  let last = null;
  for (const c of chapters) {
    const key = c.section || 'General';
    if (!last || last.key !== key) {
      last = { key, label: shortSection(c.section), items: [] };
      groups.push(last);
    }
    last.items.push(c);
  }
 
  return (
    <div className="chapters">
      <div className="ch-lbl">DRHP — {chapters.length} chapters</div>
      {groups.map((g, gi) => (
        <div key={gi}>
          <div className="ch-section">{g.label}</div>
          {g.items.map((c) => (
            <div key={c.id}
              className={`ch-item ${c.id === active ? 'on' : ''}`}
              onClick={() => onSelect(c.id)}
              title={c.title}>
              <span className={`ch-status ${DOT[c.status] || 'cs-empty'}`} />
              <span className="ch-txt">{c.title.replace(/^SECTION\s+[IVXLC]+\s*[-–—]?\s*/i, '')}</span>
              {c.page ? <span className="ch-pg">{c.page}</span> : null}
            </div>
          ))}
        </div>
      ))}
      <div className="legend">
        <div className="ch-lbl" style={{ padding: 0, marginBottom: 5 }}>Legend</div>
        <div className="lg-row"><span className="ch-status cs-done" /> Approved</div>
        <div className="lg-row"><span className="ch-status cs-review" /> In review</div>
        <div className="lg-row"><span className="ch-status cs-draft" /> Drafting</div>
        <div className="lg-row"><span className="ch-status cs-empty" /> Not started</div>
      </div>
    </div>
  );
}
 